import { Tables } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const getSurveyById = async (surveyId: Tables<'survey'>['id']) => {
    return await supabase
        .from('survey')
        .select(`
            *,
            author:user!author_id(*),
            project(*,project_members(*,user(*)),organisation(*,organisation_members(*))),
            crm(*),
            crm_config(*, crm_project(*))
        `)
        .eq('id', surveyId)
        .maybeSingle()
        .throwOnError()
        .then(res => res.data);
};
